export enum LedgerEntryColumn {
  Date = 'date',
  Journal = 'journal',
  Description = 'description',
  DocumentNumber = 'documentNumber',
  Debit = 'debit',
  Credit = 'credit',
  Balance = 'balance',
}

export const LEDGER_ENTRY_SORT_BY: Partial<Record<LedgerEntryColumn, string>> = {
  [LedgerEntryColumn.Date]: 'entryDate',
  [LedgerEntryColumn.Journal]: 'journal',
  [LedgerEntryColumn.Description]: 'description',
  [LedgerEntryColumn.DocumentNumber]: 'documentNumber',
  [LedgerEntryColumn.Debit]: 'debit',
  [LedgerEntryColumn.Credit]: 'credit',
}

export const isSortableLedgerColumn = (column: LedgerEntryColumn): boolean => column in LEDGER_ENTRY_SORT_BY
